/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";

import { Image } from "@sparefoot/react-commons";
import { H2 } from "components/core/Typography";
import { Section } from "components/core/Page";
import { ReviewCard } from "components/molecules";

import ReviewStars from "assets/icons/psp/review-stars.svg";
import TrustPilot from "assets/images/psp/trust-pilot.svg";

import "./ReviewCardList.scss";

const ReviewCardList = ({ title, testimonials }) => (
	<Section
		flush
		className="customers-saying"
	>
		<div className="review-container">
			<div className="rating-badge">
				<div className="stars-container">
					<Image src={ReviewStars} alt="Review Stars" height={34} />
				</div>
				<H2
					size="xxlarge"
					mediumSize="xlarge"
					weight="bold"
					className="section-title"
				>
					{title}
					<Image src={TrustPilot} alt="Trust Pilot Logo" />
				</H2>
			</div>
			<div className="review-grid">
				{testimonials.map((testimonial, i) => (
					<div
						className="review-grid__item"
						/* eslint-disable-next-line react/no-array-index-key */
						key={i}
					>
						<ReviewCard {...testimonial} />
					</div>
				))}
			</div>
		</div>
	</Section>
);

ReviewCardList.propTypes = {
	title: PropTypes.node.isRequired,
	testimonials: PropTypes.arrayOf(PropTypes.shape({
		body: PropTypes.string.isRequired,
		author: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		imageSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
	})).isRequired,
};

export default ReviewCardList;
